import { ASSISTANT_PENDING_TEXT } from '@/constants/chat'

/**
 * @param {Record<string, unknown>} prev
 * @param {Record<string, unknown>} patch
 */
export function patchB2bCopilotPlanDemoMessage(prev, patch) {
  return {
    ...prev,
    text: '',
    ...patch,
  }
}

/**
 * @param {(
 *   updater: (prev: Record<string, unknown[]>) => Record<string, unknown[]>
 * ) => void} setMessagesByThreadId
 * @param {string} tid
 * @param {string} pendingId
 * @param {Record<string, unknown>} patch
 */
export function updatePendingB2bDemoMessage(setMessagesByThreadId, tid, pendingId, patch) {
  setMessagesByThreadId((inner) => {
    const list = [...(inner[tid] ?? [])]
    const idx = list.findIndex((m) => m.id === pendingId)
    if (idx === -1) return inner
    const next = [...list]
    next[idx] = patchB2bCopilotPlanDemoMessage(list[idx], patch)
    return { ...inner, [tid]: next }
  })
}

/** @param {Record<string, unknown>} prev */
export function initialB2bStreamPatch(prev) {
  return patchB2bCopilotPlanDemoMessage(prev, {
    text: ASSISTANT_PENDING_TEXT,
    demoStreamActive: true,
    thoughtSummary: 'Thinking…',
    thoughtDetails: [],
    blocks: [],
  })
}
